export class SecurityInformation {
    'evidenceType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityInformation.attributeTypeMap;
    }
    constructor() {
    }
}
